import * as React from 'react';

export interface ISettings {
    onClick?: (event?: any) => void;
    label?: string;
}

const Settings: React.SFC<ISettings> = (props) => (
    <div className="builder-settings m-l-auto" onClick={props.onClick}>
        <span className="builder-settings--icon">
            <i className="nx nx-setting-o" />
        </span>
        <span data-test="option-settings" className="builder-settings--label">
            {props.label}
        </span>
    </div>
);

export default Settings;
